import React from 'react'
import { withStyles /* , Hidden  */ } from '@material-ui/core'
import Name from './Name'
import Location from './Location'
// import Notes from './Notes'
import Avatar from './Avatar'
import InboxButton from './InboxButton'
// import Activities from '../Activities'
import BottomMenu from '../MobileForm/BottomMenu'
import UserAssignment from '../UserAssignment'
import FollowUpButton from './FollowUpButton'

const Main = ({ classes, mobile, inbox, dialog, contactID }) => (
  <div className={mobile ? classes.contentMobile : classes.content}>
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: 250,
        zIndex: '-1',
        backgroundColor: '#fff',
        top: 0,
        left: 0,
      }}
    />
    <div
      style={{
        display: 'inline-block',
        verticalAlign: 'top',
        marginRight: 15,
        textAlign: 'center',
      }}
    >
      {!inbox && <Avatar mobile={mobile} />}
      {!inbox && !dialog && <InboxButton mobile={mobile} />}
    </div>
    <div
      style={{
        display: 'inline-block',
        width: inbox ? '100%' : 'calc(100% - 133px)',
      }}
    >
      <Name mobile={mobile} />
      <UserAssignment />
      <Location mobile={mobile} />
      {!contactID || contactID === 'new' ? null : (
        <>
          <FollowUpButton contactID={contactID} />
          <div style={{ marginBottom: 10 }} />
        </>
      )}
      {/* {mobile ? null : <Notes mobile={mobile} />} */}
    </div>
    {/* {mobile ? <Notes mobile={mobile} /> : null} */}
    {mobile ? <BottomMenu inbox={inbox} /> : null}
  </div>
)

export default withStyles(theme => ({
  content: {
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing.unit * 3,
    },
  },
  contentMobile: { padding: 8 },
}))(Main)
